class GameState {
  constructor() {
    this.currentChapter = 0; // 0: Menu, 1: School/Rooftop, 2: Bedroom/Computer, 3: Fantasy, 4: Garden Ending
    this.chapterProgress = {
      level1Completed: false,
      computerUnlocked: false,
      friendRequestAccepted: false,
      heartMiniGameDone: false,
      firstChatCompleted: false,
      montageCompleted: false,
      level3SealFound: false,
      level3TrialsCompleted: false,
      castleEscaped: false,
      gardenReached: false
    };
    this.activeQuest = "Begin the journey";
    this.inventory = [];
    this.load();
  }

  save() {
    try {
      const data = {
        currentChapter: this.currentChapter,
        chapterProgress: this.chapterProgress,
        activeQuest: this.activeQuest,
        inventory: this.inventory
      };
      localStorage.setItem('ritoma_save_v1', JSON.stringify(data));
    } catch (e) {
      console.warn("Save failed:", e);
    }
  }

  load() {
    try {
      const raw = localStorage.getItem('ritoma_save_v1');
      if (raw) {
        const data = JSON.parse(raw);
        if (data.currentChapter !== undefined) this.currentChapter = data.currentChapter;
        if (data.chapterProgress) this.chapterProgress = { ...this.chapterProgress, ...data.chapterProgress };
        if (data.activeQuest) this.activeQuest = data.activeQuest;
        if (data.inventory) this.inventory = data.inventory;
      }
    } catch (e) {
      console.warn("Load failed:", e);
    }
  }

  reset() {
    localStorage.removeItem('ritoma_save_v1');
    this.currentChapter = 0;
    this.chapterProgress = {
      level1Completed: false,
      computerUnlocked: false,
      friendRequestAccepted: false,
      heartMiniGameDone: false,
      firstChatCompleted: false,
      montageCompleted: false,
      level3SealFound: false,
      level3TrialsCompleted: false,
      castleEscaped: false,
      gardenReached: false
    };
    this.activeQuest = "Begin the journey";
    this.inventory = [];
  }
}

export const gameState = new GameState();
